module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeaderColor
    })
  }, [_vm._v("TONE Press Room")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-sm-offset-2",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "addressholder",
    style: ({
      borderWidth: '2px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    })
  }, [_c('strong', [_vm._v("Kara Brown")]), _vm._v(" "), _c('br'), _vm._v("\n                                kara@smithbrownmarketing.com "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("Press Releases")]), _vm._v(" "), (_vm.pressSection) ? _c('div', {
    staticClass: "presscontainer"
  }, _vm._l((_vm.pressSection), function(press) {
    return _c('div', {
      staticClass: "pressentry"
    }, [_c('h5', [_c('a', {
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "href": press.pdfUrl,
        "target": "_blank",
        "rel": "opener"
      }
    }, [_vm._v(_vm._s(press.topicSubHead))]), _vm._v(" "), _c('small', [_vm._v("\n                                    " + _vm._s(press.topicSubHeadDateFmt) + "\n                                ")])]), _vm._v(" "), _c('p', [_vm._v("\n                              " + _vm._s(press.topicSubHeadContents) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("In the News")]), _vm._v(" "), (_vm.newsSection) ? _c('div', {
    staticClass: "presscontainer"
  }, _vm._l((_vm.newsSection), function(news) {
    return _c('div', {
      staticClass: "pressentry"
    }, [_c('h5', [_c('a', {
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "href": news.pdfUrl,
        "target": "_blank",
        "rel": "opener"
      }
    }, [_vm._v(_vm._s(news.topicSubHead))]), _vm._v(" "), _c('small', [_vm._v("\n                                    " + _vm._s(news.topicSubHeadDateFmt) + "\n                                ")])]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(news.topicSubHeadContents) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    })
  }, [_vm._v("Media Access")]), _vm._v(" "), _c('div', {
    staticClass: "row mediasignup"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeaderColor
    })
  }, [_vm._v("\n                                Sign Up For Press Release.\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    attrs: {
      "id": "footer_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-md float-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: "form-control",
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "email",
      "placeholder": "email",
      "title": "invalid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon cursor"
  }, [_c('button', {
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                TONE Networks, the first brand of ChartOne Media, is a subscription- based, short form video and social network. The platform features bite-sized videos from highly sought after, credentialed experts covering a range of topics. Designed to effortlessly integrate into the lives of busy women, TONE Networks offers personalized content with actionable tips and access to both expert coaching and peer to peer advice. TONE Networks reinforces the growing women helping women movement by providing a supportive online community complete with live chats and events with its experts, providing a vibrant, supportive community for women.\n                            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a416555a", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a416555a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/PressRelease.vue